import assetPath from '/app/packages/lebenslauf/articles/src/assets/hobbys-lebenslauf.jpg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')